const modes = [
    {
        name: "Simple",
        image: [
            <svg
                key="simple"
                viewBox="0 0 90.00013 80.960342"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="m.12781732 63.148c-1.0873-16.95 4.92119998-30.276 11.98099968-38.025 7.061-7.748 16.575-11.446 30.719-14.004 14.144-2.559 34.331 2.049 47.122-11.119 2.023 81.879-57.465 93.65-86.5959997 70.468 10.1519997-12.225 21.5169997-20.905 37.0709997-26.579 11.169-4.075 21.273-6.103 31.66-18.084-15.198 10.33-27.431 11.088-36.471 13.939-13.429 4.236-24.045 9.926-35.48599968 23.404z"
                    fillRule="evenodd"
                />
            </svg>,
        ],
    },
    {
        name: "Logo",
        image: [
            <svg
                key="logo"
                viewBox="0 0 90 90"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    clipRule="evenodd"
                    d="m76.8198 13.1802c8.4391 8.4391 13.1802 17.8851 13.1802 29.8198h-30.1322c-.9778-7.3387-7.2616-13-14.8678-13s-13.89 5.6613-14.8678 13h-30.1322c.00001-11.9347 4.74107-21.3807 13.1802-29.8198 8.4391-8.43914 19.8851-13.1802 31.8198-13.1802s23.3807 4.74106 31.8198 13.1802zm-31.8198 46.8198c-7.6062 0-13.89-5.6613-14.8678-13h-30.1322c0 11.9347 4.74106 21.3807 13.1802 29.8198 8.4391 8.4391 19.8851 13.1802 31.8198 13.1802s23.3807-4.7411 31.8198-13.1802 13.1802-17.8851 13.1802-29.8198h-30.1322c-.9778 7.3387-7.2616 13-14.8678 13zm0-4c6.0751 0 11-4.9249 11-11s-4.9249-11-11-11-11 4.9249-11 11 4.9249 11 11 11z"
                    fillRule="evenodd"
                />
            </svg>,
        ],
    },
    {
        name: "Icon",
        image: [
            <svg
                key="icon"
                viewBox="0 0 80 76.208847"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="m50.000001 974.36218c3.185174 0 9.3314-11.02653 12.360681-10.04226 3.029281.98428 1.520446 13.51759 4.097306 15.38979s14.030495-3.4358 15.902693-.85894c1.872199 2.57686-6.715371 11.82966-5.731098 14.85894s13.370417 5.4673 13.370417 8.65249c0 3.1852-12.386145 5.6232-13.370418 8.6525-.984273 3.0292 7.603295 12.282 5.731096 14.8589-1.872198 2.5769-13.325831-2.7311-15.902692-.8589-2.57686 1.8722-1.068027 14.4055-4.097309 15.3897-3.02928.9843-9.175503-10.0422-12.360678-10.0422-3.185174 0-9.3314 11.0265-12.360681 10.0422-3.029281-.9842-1.520446-13.5175-4.097306-15.3897s-14.030495 3.4358-15.902693.8589c-1.872199-2.5769 6.715371-11.8297 5.731098-14.8589-.984273-3.0293-13.3704171-5.4673-13.370417-8.6525 0-3.18519 12.386145-5.62321 13.370418-8.65249s-7.603295-12.28208-5.731096-14.85894c1.872198-2.57686 13.325831 2.73113 15.902692.85894 2.57686-1.8722 1.068027-14.40552 4.097309-15.38979 3.02928-.98427 9.175503 10.04226 12.360678 10.04226z"
                    transform="translate(-10 -964.25774)"
                />
            </svg>,
        ],
    },
    {
        name: "Artistic",
        image: [
            <svg
                key="artistic"
                viewBox="0 0 86.239883 73.107674"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="m84.242386 27.916677a43.779 43.779 0 0 0 -2.03-3.934l-9.572 26.006a8.972 8.972 0 0 1 -1.57 2.663c10.521-.984 18.2-12.033 14-22.716-.258-.686-.534-1.353-.828-2.019z" />
                <path d="m29.293386 4.4896766a44.079 44.079 0 0 0 -26.1510003 57.8700004c.059.118.1.235.157.353 5.038 12.311 22.0000003 13.938 29.3660003 2.862a31.341 31.341 0 0 1 14.507-11.782c.188-.074.379-.13.567-.2a11.607 11.607 0 0 1 7.236-6.474 9.117 9.117 0 0 1 .846-4.094l14.816-32.076a44.165 44.165 0 0 0 -41.344-6.4590004zm-11.493 48.9310004a7.5 7.5 0 1 1 7.5-7.5 7.5 7.5 0 0 1 -7.5 7.5zm9.375-21.563a7.5 7.5 0 1 1 7.5-7.5 7.5 7.5 0 0 1 -7.5 7.5zm22.5-6.562a7.5 7.5 0 1 1 7.5-7.5 7.5 7.5 0 0 1 -7.5 7.5z" />
                <path d="m83.384386.26667659a3.484 3.484 0 0 0 -4.5 1.75700001l-19.658 42.5730004a5.359 5.359 0 0 0 1 5.962 7.92 7.92 0 0 0 -9.114 4.67c-3.037 7.331 1.766 10.548-1.27 17.879 0 0 11.378-.809 15.933-11.806a7.909 7.909 0 0 0 -2.344-9.162 5.345 5.345 0 0 0 5.694-3.445l16.194-44.0120004a3.483 3.483 0 0 0 -1.935-4.41600001z" />
            </svg>,
        ],
    },
    {
        name: "Anime",
        image: [
            <svg
                key="comic-book"
                enableBackground="new 0 0 100 100"
                viewBox="0 0 100 100"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="m50 0c-27.57 0-50 22.43-50 50s22.43 50 50 50 50-22.43 50-50-22.43-50-50-50zm0 90.644c-22.411 0-40.644-18.233-40.644-40.644s18.233-40.644 40.644-40.644 40.644 18.233 40.644 40.644-18.233 40.644-40.644 40.644z" />
                <path d="m50 15.578c-19.01 0-34.421 15.412-34.421 34.422 0 19.011 15.411 34.422 34.421 34.422 19.012 0 34.422-15.411 34.422-34.422 0-19.01-15.411-34.422-34.422-34.422zm15.095 55.674-15.019-8.283-14.92 8.279 2.696-16.812-12.027-11.874 16.815-2.345 7.435-15.268 7.534 15.318 16.565 2.288-12.025 11.881z" />
            </svg>,
        ],
    },
    {
        name: "Line Art",
        image: [
            <svg
                key="line-art"
                enableBackground="new 0 0 50 50"
                viewBox="0 0 49.666 49.667999"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path d="m24.833 0c-13.693 0-24.833 11.14-24.833 24.833 0 13.694 11.14 24.835 24.833 24.835s24.833-11.141 24.833-24.835c0-13.693-11.14-24.833-24.833-24.833zm0 42.668c-9.833 0-17.833-8.001-17.833-17.835 0-9.833 8-17.833 17.833-17.833s17.833 8 17.833 17.833c0 9.834-8 17.835-17.833 17.835z" />
                <path d="m24.833 11.244c-7.494 0-13.59 6.096-13.59 13.59s6.096 13.59 13.59 13.59c7.493 0 13.59-6.097 13.59-13.59s-6.097-13.59-13.59-13.59zm0 20.18c-3.634 0-6.59-2.956-6.59-6.59s2.957-6.59 6.59-6.59 6.59 2.956 6.59 6.59-2.956 6.59-6.59 6.59z" />
            </svg>,
        ],
    },
    {
        name: "Low Poly",
        image: [
            <svg
                key="low-poly"
                viewBox="0 0 56 56"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g transform="translate(-4 -4)">
                    <path d="m59 60h-54l27-16z" />
                    <path d="m60 58-27-16v-38z" />
                    <path d="m31 4v38l-27 16z" />
                </g>
            </svg>,
        ],
    },
];

export default modes;
